import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';

import ProductsAction from '../app/store/actions/products';
import ModalComponent from '../components/modal';
import Notification from '../components/notifications';
import TableRegisterButton from '../components/table/registerButton';
import Table from '../components/table/table';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';

class ProductsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 20,
      show: false,
      page: 1,
      search: '',
      showModal: false,
      orderBy: 'ASC',
      field: 'code',
      titleModal: '',
      descriptionModal: '',
      message: '',
      showError: false,
      errorMessage: '',
    };
  }

  componentDidMount() {
    this.searchProducts();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchProducts();
  }

  searchProducts = async () => {
    const {
      search, page, limit, orderBy, field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.searchItems(limit, skip, search, orderBy, field);
  }

  activeProduct = async (soneparId, spotlight) => {
    try {
      await this.props.updateProduct(soneparId, spotlight);
      await this.searchProducts();
    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.error) {
        if (error.response && error.response.data.error.code === 1202) {
          await this.deleteErrorNotification(I18n.t('categoryNotActivated'));
        } else if (error.response && error.response.data.error.code === 1201) {
          await this.deleteErrorNotification(I18n.t('categoryNotFound'));
        } else if (error.response && error.response.data.error.code === 700) {
          await this.deleteErrorNotification(I18n.t('productNotFound'));
        } else {
          await this.deleteErrorNotification(I18n.t('errorOcurred'));
        }
      } else {
        await this.deleteErrorNotification(I18n.t('unknownError'));
      }
    }
  }

  spotProduct = async (soneparId, isSpot) => {
    try {
      await this.props.updateSpotProduct(soneparId, isSpot);
      await this.searchProducts();
    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.error) {
        if (error.response.data.error.code === 1202) {
          await this.deleteErrorNotification(I18n.t('categoryNotActivated'));
        } else if (error.response.data.error.code === 1201) {
          await this.deleteErrorNotification(I18n.t('categoryNotFound'));
        } else if (error.response.data.error.code === 700) {
          await this.deleteErrorNotification(I18n.t('productNotFound'));
        } else {
          await this.deleteErrorNotification(I18n.t('errorOcurred'));
        }
      } else {
        await this.deleteErrorNotification(I18n.t('unknownError'));
      }
    }
  }

  disableProductModal = async (soneparId, isDisable) => {
    this.messagesDisableProduct(isDisable);
    await this.setState({ selectItemToDisable: { soneparId, isDisable }, showModal: true });
  }

  disableProduct = async () => {
    const { selectItemToDisable } = this.state;

    try {
      if (selectItemToDisable) {
        const { soneparId, isDisable } = selectItemToDisable;

        await this.setState({ showModal: false });
        await this.props.updateDisableProduct(soneparId, !isDisable);
        await this.setState({ selectItemToDisable: undefined });
        await this.searchProducts();
        this.deleteNotification();
      }
    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.error) {
        if (error.response.data.error.code === 1202) {
          await this.deleteErrorNotification(I18n.t('categoryNotActivated'));
        } else if (error.response.data.error.code === 1201) {
          await this.deleteErrorNotification(I18n.t('categoryNotFound'));
        } else if (error.response.data.error.code === 700) {
          await this.deleteErrorNotification(I18n.t('productNotFound'));
        } else {
          await this.deleteErrorNotification(I18n.t('errorOcurred'));
        }
      } else {
        await this.deleteErrorNotification(I18n.t('unknownError'));
      }
    }
  }

  messagesDisableProduct = async (isDisable) => {
    if (!isDisable) {
      await this.setState({
        descriptionModal: I18n.t('disableProductBodyModal'),
        titleModal: I18n.t('disableProductTitleModal'),
        message: I18n.t('productDisable'),
      });
    } else {
      await this.setState({
        descriptionModal: I18n.t('activeProductBodyModal'),
        titleModal: I18n.t('activeProductTitleModal'),
        message: I18n.t('productActive'),
      });
    }
  }

  deleteNotification = () => {
    this.setState({ show: true });
    setTimeout(() => { this.setState({ show: false }); }, 5000);
  }

  deleteErrorNotification = (errorMessage) => {
    this.setState({ showError: true, errorMessage });
    setTimeout(() => { this.setState({ showError: false, errorMessage: '' }); }, 5000);
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchProducts();
  }

  render() {
    const { products = {} } = this.props;
    const {
      limit, show, page, showModal, showError,
    } = this.state;

    const tableHeader = [
      { key: 'code', value: I18n.t('code') },
      { key: 'description', value: I18n.t('product') },
      { key: 'brand', value: I18n.t('brand') },
      { key: 'category', value: I18n.t('category') },
      { key: 'spot', value: I18n.t('spot') },
      { key: 'spotlight', value: I18n.t('spotlight') },
      { key: 'isDisable', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = (products.rows || []).map((row, index) => ({
      key: index,
      code: row.code,
      description: row.description,
      brand: row.brand.description,
      category: row.category.name,
      spot: (
        <div className="row margin-left-0">
          <button
            type="button"
            onClick={() => this.spotProduct(row.soneparId, !row.isSpot)}
            className={row.isSpot ? 'btn btn-warning promotion-btn-warning' : 'btn btn-dark promotion-btn-active'}
          >
            <Translate value={row.isSpot ? 'disable' : 'active'} />
          </button>
        </div>
      ),
      spotlight: (
        <div className="row margin-left-0">
          <button
            type="button"
            onClick={() => this.activeProduct(row.soneparId, !row.spotlight)}
            className={row.spotlight ? 'btn btn-warning promotion-btn-warning' : 'btn btn-dark promotion-btn-active'}
          >
            <Translate value={row.spotlight ? 'disable' : 'active'} />
          </button>
        </div>
      ),
      isDisable: (
        <div className="row margin-left-0">
          <button
            style={{ marginLeft: '0px' }}
            type="button"
            onClick={() => this.disableProductModal(row.soneparId, row.isDisable)}
            className={!row.isDisable ? 'btn btn-danger' : 'btn btn-dark promotion-btn-active'}
          >
            <Translate value={!row.isDisable ? 'disable' : 'active'} />
          </button>
        </div>
      ),
      action: (
        <div style={{ marginLeft: '0px' }} className="row edit-div">
          <button
            type="button"
            onClick={() => history.push({
              pathname: ROUTES.FORM,
              screenComming: 'products',
              item: row,
            })}
            className="btn btn-secondary"
          >
            <Translate value="edit" />
          </button>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'products' }} />
        <button
          onClick={() => history.push(ROUTES.UPLOAD_PRODUCTS)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="import" />
        </button>

        <button
          onClick={() => this.props.getCsvProductsReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={this.state.titleModal}
          body={this.state.descriptionModal}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={this.disableProduct}
        />
        <Table
          title={I18n.t('products')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={products.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
        {show && <Notification classe="success" message={this.state.message} /> }
        {showError && <Notification classe="danger" message={this.state.errorMessage} /> }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchItems: (limit, skip, search, order, field) => dispatch(
    ProductsAction.getSearchPanelProducts(limit, skip, search, order, field),
  ),
  updateProduct: (soneparId, spotlight) => dispatch(ProductsAction.updateProductSpotlight(soneparId, spotlight)),
  updateSpotProduct: (soneparId, isSpot) => dispatch(ProductsAction.updateProductIsSpot(soneparId, isSpot)),
  updateDisableProduct: (soneparId, isDisable) => dispatch(ProductsAction.updateProductIsDisable(soneparId, isDisable)),
  deleteProduct: soneparId => dispatch(ProductsAction.deleteProduct(soneparId)),
  getCsvProductsReport: () => dispatch(ProductsAction.getCsvProductsReport()),
});

const mapStateToProps = state => ({
  products: state.products && state.products.products,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);
